module.exports = __webpack_public_path__ + "static/media/close_participant.2d9473ef.svg";